export default "__VITE_ASSET__CcOMfEey__"